module.exports = __webpack_public_path__ + "static/media/countdown-3.5b5daf7e.mp3";